import TierInfo from "components/TierInfo";
import { BillingTierFeature } from "types/generated";

const TemplatesFeatureGateCallout = () => (
  <TierInfo
    type="callout"
    variant="danger"
    feature={BillingTierFeature.Blueprints}
    title="Templates are not supported by your plan"
  >
    You may still preview or delete the templates that you have created but you will not be able to
    create deployments with them. Upgrade to <strong>Business plan or higher</strong> to be able to
    use the feature again.
  </TierInfo>
);

export default TemplatesFeatureGateCallout;
